import type { RouteLocationRaw, RouteRecordRaw } from 'vue-router';
import gettext from 'src/utils/gettext';

const { $gettext } = gettext;

// Standalone redirect route (not wrapped in layout)
export const profileSyncRoute: RouteRecordRaw = {
  // calendar sync redirect from back
  path: '/profile/synchronize-calendar',
  redirect: (): RouteLocationRaw => {
    return { name: 'calendar-sync' };
  },
};

// Children of /profile layout route
export const profileRoutes: RouteRecordRaw[] = [
  {
    path: '',
    name: 'profile',
    component: () => import('src/pages/profile/ProfilePage.vue'),
  },
  {
    path: 'calendar-sync',
    alias: $gettext('synchronizace-kalendare'),
    name: 'calendar-sync',
    component: () => import('src/pages/profile/CalendarSyncPage.vue'),
  },
];

// Účet → web `/profile` (`/profil`).
export const mobileProfileRoutes: RouteRecordRaw[] = [
  // No guard: the account screen must stay reachable for every signed-in
  // user, so the bottom nav is never a dead end.
  {
    path: 'profile',
    alias: $gettext('profil'),
    name: 'profile',
    meta: { bottomNav: true },
    component: () => import('pages/mobile/MobileAccountPage.vue'),
  },
];
